/* eslint-disable no-console */
import environment from "src/utils/environment";

if (environment.isBrowser) {
  window.require = new Proxy(function () {}, {
    apply: function (target, thisArg, argList) {
      if (argList[0] === "electron-log") {
        const log = (...args) => console.log(...args);
        log.error = (...args) => console.error(...args);
        return log;
      }

      if (argList[0] === "@electron/remote") {
        return {};
      }

      return undefined;
    }
  });
}
